import type { ValueOf } from 'type-fest'
import { Interval } from 'src/services/apollo/generated/graphql'
import type { MembershipPlan } from 'src/services/helpers/membership'

type MembershipPlanPrice = ValueOf<ValueOf<MembershipPlan['prices']>>

function getPriceNumber(
  interval: Interval,
  prices: Pick<
    MembershipPlanPrice,
    'perMonth' | 'perYear' | 'perMonthOriginal' | 'perYearOriginal'
  >,
) {
  if (interval === Interval.Month) {
    return {
      current: prices.perMonth,
      original: prices.perMonthOriginal,
    }
  }

  return {
    current: prices.perYear / 12,
    original: prices.perYearOriginal / 12,
  }
}

export function getMembershipPlanDiscountPercentage(
  prices: MembershipPlanPrice,
  interval: Interval,
) {
  const { current, original } = getPriceNumber(interval, prices)

  if (!original || current === original) {
    return undefined
  }

  const discount = 100 - Math.ceil((current / original) * 100)
  return discount > 0 ? discount : undefined
}
